import { createContext } from 'react';
export const BrandConfigurationContext = createContext(null);
export const BrandConfigurationProvider = BrandConfigurationContext.Provider;
